import { FC } from "react";

import SitesVisual from "../../../../assets/images/content/pillar-2/industrial-footprint/applia-members-manufacturing-sites-in-europe.svg";
import { DATAWRAPPER_MEMBERS_MAP_URL } from "../../../../config/env";

const MembersManufacturingSites: FC = () => {
	return (
<>
	<h3 className="mb-4 text-lg text-gray-800 font-bold">APPLiA Direct Members manufacturing sites in Europe</h3>
	<div className="flex flex-col md:flex-row items-center content-center justify-center">
  <img
    className="block w-full md:w-1/3 max-w-md self-start"
    src={SitesVisual}
  />
  <div className="w-full md:w-2/3" style={{ position: 'relative', height: '550px' }}>
    <iframe
      title="My Chart"
      aria-label="chart"
      src={DATAWRAPPER_MEMBERS_MAP_URL}
      scrolling="no"
      frameBorder="0"
      style={{ width: '100%', border: 'none', height: '550px' }}
    />
  </div>
</div>
</>
  );
};

export { MembersManufacturingSites };

